
import './App.css';
import BoardTemplate from './components/BoardTemplate';

function App() {
  return (
    <div id="app">
      <BoardTemplate/>
    </div>
  );
}

export default App;
